import { client as axiosClient } from '../../store/client'
import * as Beef from './generated'

export { Beef }

export const client = Beef.createClient(axiosClient)
